import { ICandidateResult } from "../types";

export const initData: ICandidateResult = {
  request_uuid: "",
  candidate: {
    id: "",
    resume_link: "",
    matching_score: 0,
    salary: "",
    relevant_experience_duration: 0,
    inclusion_reason: "",
    skills_influenced: [],
    desired_position: "",
    positive_skills: [],
    negative_skills: [],
    birth_data: "",
    business_trip_readiness: "",
    relocation: "",
    age: 0,
    source: "",
    gender: "",
    city: "",
    total_experience: 0,
    education: [],
    citizenship: [],
    warnings: [],
    viewed: false,
    rating: null,
  },
};
